const formatDate = (date, locale) => new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
}).format(new Date(date));
export function getLocalizedDate(dateStr, locale) {
    return dateStr && locale && formatDate(dateStr, locale);
}
